import { createContext, use } from "react";

import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";

export type Decision = typeof ReportReviewerStatus.Approved | typeof ReportReviewerStatus.ChangesRequested;

export type FinishReviewValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
  /** The reviewer's, a menu item's or the dialog's opening choice; undefined until the dialog picks one. */
  decision: Decision | undefined;
  setDecision: (decision: Decision) => void;
  note: string;
  setNote: (note: string) => void;
  /** Opens the dialog with that option, or none so the dialog picks one; the note draft is kept. */
  openFinishReview: (decision?: Decision) => void;
  discard: () => void;
};

export const FinishReviewContext = createContext<FinishReviewValue | null>(null);

/** The opener, or undefined when rendered outside the provider (menu items then stay disabled). */
export const useOpenFinishReview = (): FinishReviewValue["openFinishReview"] | undefined =>
  use(FinishReviewContext)?.openFinishReview;

export const useFinishReview = (): FinishReviewValue => {
  const value = use(FinishReviewContext);
  if (!value) throw new Error("useFinishReview must be used inside FinishReviewProvider");
  return value;
};
